// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"a35cd653","354":"62116ba5","459":"730ef648","478":"9c219058","562":"81ff765e","774":"034b0555"}[chunkId] + ".chunk.js";
};